import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import LogInContext from '../../../context/LogInContext'
import { summonAutopayScript } from '../../../helpers'

function SecuredLoanButton({ className, children }) {
  useEffect(() => summonAutopayScript(), [])

  return (
    <LogInContext.Consumer>
      {() => (
        <a type="button" className={className} href="#top" data-event="apply">
          {children}
        </a>
      )}
    </LogInContext.Consumer>
  )
}

SecuredLoanButton.propTypes = {
  className: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired
}
export default SecuredLoanButton
